import styles from "./blog-index.module.scss";
import ArticleCard from "~/components/Blog/ArticleCard";
import BlogHeader from "~/components/Blog/BlogHeader";
import Layout from "~/components/layouts/Blog";
import Pagination from "~/components/Blog/Pagination";
import Head from "~/components/Meta/Head";
import { blog as blogConfig, exclude_filter } from "~/config/blog";
import { getPage } from "~/utils/Blog/Page";
import { getPosts, getFeaturedPosts } from "~/utils/Blog/Post";
import API from "~/config/api";
import { getIronSession } from "iron-session";
import { sessionOptions } from "~/config/session";
import { validate_user } from "~/utils/authServer";
import CTA from "~/components/Common/CTA";
import { BLOG_FUNNEL } from "~/config/funnel";

const Index = ({ page, ghost, featured }) => {
  return (
    <>
      <Head
        title={"Resource Center | RealEstateAgents.com"}
        description={page?.meta_description}
        socialImageUrl={page?.og_image || page?.twitter_image}
        url={`${process.env.CLIENT_ORIGIN}${blogConfig.baseUrl}`}
      />
      <div className={styles["blog-index"]}>
        <div className={styles["blog-index__container"]}>
          <main className={styles["blog-index__main"]}>
            <BlogHeader
              heading={page.title}
              content={page.custom_excerpt}
              className={styles["--full-width"]}
            />
            {ghost.posts.map((post, key) => {
              return <ArticleCard post={post} key={key} />;
            })}
            <div className={styles["--full-width"]}>
              {ghost?.meta?.pagination?.total > blogConfig.pageLimit && (
                <Pagination pagination={ghost.meta.pagination} />
              )}
            </div>
          </main>
          <aside className={styles["blog-index__sidebar"]}>
            <div className={styles["blog-index__sidebar-container"]}>
              <div className={styles["blog-index__cta-container"]}>
                <CTA page={"blog"} funnel={BLOG_FUNNEL} />
              </div>
              <div className={styles["blog-index__sidebar-heading"]}>
                Featured Blog Posts
              </div>
              {featured.posts.map((post, key) => {
                return <ArticleCard minimal={true} post={post} key={key} />;
              })}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};

Index.getLayout = function getLayout(page) {
  return <Layout {...page.props}>{page}</Layout>;
};

export const getServerSideProps = async ({ req, res }) => {
  const session = await getIronSession(req, res, sessionOptions);
  let hide_tags = true;

  if (session.auth) {
    const user_auth = await validate_user(req, res, API.Auth.validate({}));
    if (user_auth?.isLoggedIn && user_auth?.user?.is_prime) {
      hide_tags = false;
    }
  }

  let filters = hide_tags ? exclude_filter() : null;

  const [posts_res, featured_res, page_res] = await Promise.all([
    getPosts({ filters }),
    getFeaturedPosts({}),
    getPage({ slug: "blog" }),
  ]);

  const [ghost, featured, page] = await Promise.all([
    posts_res.data,
    featured_res.data,
    page_res.data.pages[0],
  ]);

  return { props: { ghost, featured, page, blog_hide_tags: hide_tags } };
};

export default Index;
